<div class="mb-2 comment-preview-component-container">
  @if (displayValue) {
    <span
      class="comment-edited-container ql-editor"
      [ngClass]="{
        'truncate-text': truncateText && isTruncated,
        'preview-title': isPreviewTitle,
      }"
      [innerHTML]="displayValue | safeHtml"
      [style.color]="textColor"
      [style.fontSize]="fontSize"
      [attr.title]="isPreviewTitle ? displayValue : null"></span>
  }
  @if (attachments?.length) {
    <div class="my-3" [style.margin-left]="'-8px'" [style.margin-right]="'-8px'">
      <button
        type="button"
        class="d-block ms-2 me-2 mb-2 border-0 bg-transparent p-0"
        [style.font-size]="'12px'"
        (click)="showFiles = !showFiles">
        <div class="d-flex align-items-center pointer">
          <span class="me-2">{{ attachments.length }} File(s)</span>
          <i
            [style.font-size]="'14px'"
            class="fa"
            [ngClass]="{ 'fa-caret-right': !showFiles, 'fa-caret-down': showFiles }"></i>
        </div>
      </button>
      @if (showFiles) {
        <div class="d-flex align-items-start text-center mt-2 mb-2 flex-wrap">
          @for (attachment of attachments; track attachment.id || $index) {
            <div
              class="d-flex text-center pointer file-content ms-2 me-2 mb-2"
              [style.position]="'relative'"
              [style.width]="'80%'">
              <hr-badgebtn-subcmp
                [file]="attachment"
                [isDisplayTrashBtn]="showDeleteFile"
                (onTrashFile)="deleteFile(attachment)"
                [directPreview]="true"></hr-badgebtn-subcmp>
              <hr-grid-subcmp
                [file]="attachment"
                [subSectionId]="subSectionId"
                [compactView]="true"
                [hideDeleteButton]="showDeleteFile"
                class="w-100"
                [forTranscript]="true"
                (deleteCallback)="deleteFile(attachment)"
                [projectId]="project.id"></hr-grid-subcmp>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
